import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { ResellerTokens } from '@utils/types/resellers/reseller-token.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';

export interface CreateTokenPayload {
  name: string;
  type: string;
  years_valid: number;
}

export function useCreateResellerToken(customerId: number) {
  const queryClient = useQueryClient();

  return useMutation<ResellerTokens, AxiosError<BaseError>, CreateTokenPayload>(
    async (payload: CreateTokenPayload) => {
      const { name, type, years_valid } = payload;

      const response = await Axios.post<ResellerTokens>(
        `${POST_URL(customerId.toString()).createResellerToken}`,
        {
          name,
          type,
          years_valid
        }
      );
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('resellerTokens');
      },
      onError: () => {}
    }
  );
}
